

import { ApplicationUserModel, NotRatedOptionReasonModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { notRatedOptionReasonsStore } from '@/libs/not-rated-option-reasons/+state/store';

@Component({})
export default class NotRatedOptionReasonDialog extends Page {

    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    notRatedOptionReason : NotRatedOptionReasonModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.notRatedOptionReason?.id == Guid.EmptyGuid();
    }
    
    open (id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close () {
        this.dialog = false;
    }

    private load (): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadNotRatedOptionReason().then((e) => {
                    this.loading = false;
                    resolve(e);
                }).catch((e: any) => {
                    reject(e);
                });
            });
        }
        else {
            this.notRatedOptionReason = {
                id: Guid.EmptyGuid(),
                name: ""
            } as NotRatedOptionReasonModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadNotRatedOptionReason() {
        return new Promise((resolve, reject) => {
            notRatedOptionReasonsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(notRatedOptionReasonsStore, CrudReponse.Get).then((e) => {
                this.notRatedOptionReason = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private save () {
        if (this.form.validate()) {
            const notRatedOptionReason = {...this.notRatedOptionReason};
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                notRatedOptionReasonsStore.dispatch(CrudAction.Create, { item: notRatedOptionReason });
                this.subscribe(notRatedOptionReasonsStore, CrudReponse.Create).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                notRatedOptionReasonsStore.dispatch(CrudAction.Update, { item: notRatedOptionReason });
                this.subscribe(notRatedOptionReasonsStore, CrudReponse.Update).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteNotRatedOptionReason () {
        this.deleting = true;
        notRatedOptionReasonsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(notRatedOptionReasonsStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
